import { API as e, Resource as t } from "@coveo/platform-client";
// src/resources/PrivateLicenseResource.ts
var n = class n extends t {
	static {
		this.baseUrl = `/api/private/organizations/${e.orgPlaceholder}/license/products`;
	}
	products() {
		return this.api.get(n.baseUrl);
	}
};
export { n as PrivateLicenseResource };

//# sourceMappingURL=PrivateLicenseResource.js.map